import React, { PureComponent } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';

import RouterRedirect from '../RouterRedirect/RouterRedirect';
import { RootState } from '../../configs/store';

interface PrivateRouteProps {
  isAuthenticated?: boolean,
  render: any,
  exact: boolean,
  path: string | string[]
}

class PrivateRoute extends PureComponent<PrivateRouteProps> {

  render() {
    const { isAuthenticated, render: Component, exact, path } = this.props;

    return (
      <Route
        exact={ exact }
        path={ path }
        render={
          () =>
            isAuthenticated ? <Component /> : <RouterRedirect to="/" />
        }
      />
    );
  }

}

const mapState = (state: RootState) => ({
  isAuthenticated: state.auth.authenticated
});

export default connect(mapState, null)(PrivateRoute);
